import React, { useState } from 'react';
import PropTypes from 'prop-types';
import searchSvg from '../../static/images/search.svg';

import './style.scss';

// Component

function Search({
    handleSearchSubmit,
    placeholder = '',
    customClass = '',
    search,
    setSearch,
}) {
    return (
        <div className={`tableSearch ${customClass}`}>
            <input
                type="text"
                onChange={el => setSearch(el.target.value)}
                value={search}
                placeholder={placeholder}
                onKeyPress={event => {
                    if (event.key === 'Enter') {
                        handleSearchSubmit(search);
                    }
                }}
            />
            <img
                src={searchSvg}
                alt="search"
                onClick={() => {
                    handleSearchSubmit(search);
                }}
            />
        </div>
    );
}

Search.propTypes = {
    handleSearchSubmit: PropTypes.func,
    placeholder: PropTypes.string,
    customClass: PropTypes.string,
    search: PropTypes.string,
    setSearch: PropTypes.func,
};

export default Search;
